import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import {
	Bar,
	BarChart,
	CartesianGrid,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis
} from 'recharts'

import queryKeys from '../../queries/queryKeys'
import fetchDashboardCompletedJobsByHour from '../../queries/dashboard/fetchDashboardCompletedJobsByHour'
import { SECONDARY_COLOR } from '../useFrequenciesPicker'

interface Props {
	weeksBack: number;
}

function CompletedJobsByHourChart({ weeksBack }: Props) {
	const { t } = useTranslation('pages')
	const { data, isFetching } = useQuery({
		queryKey: queryKeys.dashboard.completedJobsByHour(weeksBack),
		queryFn: () => fetchDashboardCompletedJobsByHour(weeksBack),
		staleTime: 1000 * 60,
		cacheTime: 1000 * 60 * 10
	})

	const isSynced = data?.weeksBack === weeksBack
	const chartData = isSynced ? data?.hours || [] : []

	return (
		<div style={{
			width: 420,
			height: 220,
			marginTop: 16,
			opacity: isFetching ? 0.65 : 1
		}}>
			<div className={'font-semibold mb-2'}>
				{t('pages:Hotové zákazky podľa hodiny')}
			</div>
			<ResponsiveContainer width={'100%'} height={'100%'}>
				<BarChart
					data={ chartData }
					margin={{
						top: 5,
						right: 12,
						left: 0,
						bottom: 20
					}}
				>
					<CartesianGrid strokeDasharray="3 3" />
					<XAxis dataKey={'hour'} />
					<YAxis allowDecimals={ false } />
					<Tooltip formatter={(value: number) => `${value}`} />
					<Bar
						dataKey={'count'}
						name={ t('pages:Počet hotových zákaziek') }
						fill={ SECONDARY_COLOR }
						radius={[4, 4, 0, 0]}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	)
}

export default CompletedJobsByHourChart
